import Cookies from 'js-cookie';

export default function init(elements: HTMLAnchorElement[]): void {
  applyOfferCodes(elements);
}

export function applyOfferCodes(elements: HTMLAnchorElement[]) {
  const campaignCode = Cookies.get('campaignCode');
  const affiliateCode = Cookies.get('affiliateCode');

  elements.forEach((a) => {
    // href will always be set to a full URL including the domain
    const url = new URL(a.href, window.location.origin);

    // Check if the URL has a path segment beyond the domain
    // We'll normalize the path by removing any leading/trailing slashes
    const normalizedPath = url.pathname.replace(/^\/|\/$/g, '');

    // Only modify URLs that have no path (just domain with or without trailing slash)
    // and skip if the path is "account"
    if (normalizedPath !== 'account') {
      // Build new path with affiliate/campaign codes
      const newPath = `${affiliateCode ? `/a/${affiliateCode}` : ''}${campaignCode ? `/c/${campaignCode}` : ''}`;

      // Update the URL pathname if we have codes to add
      if (newPath) {
        url.pathname = newPath;
        a.href = url.toString();
      }
    }

    a.classList.remove('quote-link');
  });
}
